import { render, staticRenderFns } from "./features-summary-list.vue?vue&type=template&id=41aef316&scoped=true&"
import script from "./features-summary-list.vue?vue&type=script&lang=js&"
export * from "./features-summary-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41aef316",
  null
  
)

export default component.exports